import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { ClientsRoutingModule } from './clients-routing.module';
import { ClientListComponent } from './components/client-list/client-list.component';
import { ClientFormComponent } from './components/client-form/client-form.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SearchComponent } from '../../shared/components/search/search.component';
import { FileUploaderComponent } from '../../shared/components/file-uploader/file-uploader.component';
import { ClientDetailsComponent } from './components/client-details/client-details.component';
import { ComponentsModule } from '../../components/components.module';
// import { GoogleDriveUploaderComponent } from '../../shared/components/google-drive-uploader/google-drive-uploader.component';
@NgModule({
  declarations: [
    ClientListComponent,
    ClientFormComponent,
    ClientDetailsComponent
  ],
  imports: [
    CommonModule,
    ClientsRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatIconModule,
    FormsModule,
    MatCheckboxModule,
    SearchComponent,
    // GoogleDriveUploaderComponent,
    FileUploaderComponent,
    MatTabsModule,
    MatExpansionModule,
    ComponentsModule
  ]
})
export class ClientsModule { }
